import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../views/Login.vue'
import Logout from '../views/Logout.vue'
// import Store from "@/store/index.js";

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'login',
		component: Login
	},
	{
		path: '/logout',
		name: 'logout',
		component: Logout
	},
	{
		path: '/export-products',
		name: 'exportProducts',
		component: () => import('../views/ExportProducts.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/export-popi',
		name: 'exportPoPi',
		component: () => import('../views/ExportPOPI.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/export-po-pdf',
		name: 'exportPoPDF',
		component: () => import('../views/ExportPoPDF.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/import-brand-discount',
		name: 'importBrandDiscount',
		component: () => import('../views/ImportBrandDiscount.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/import-buyonegetone',
		name: 'importBuyOneGetOne',
		component: () => import('../views/ImportBuyOneGetOne.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/import-shop-products',
		name: 'importShopProducts',
		component: () => import('../views/ImportShopProducts.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/dashboard',
		name: 'dashboard',
		component: () => import('../views/Dashboard.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/orders',
		name: 'orders',
		component: () => import('../views/Orders.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/brand-price-adjustment',
		name: 'brandPriceAdjustment',
		component: () => import('../views/BrandPriceAdjustmentList.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/brand-price-adjustment/edit/:id',
		name: 'editBrandPriceAdjustment',
		component: () => import('../views/BrandPriceAdjustment.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/brand-price-adjustment/add',
		name: 'addBrandPriceAdjustment',
		component: () => import('../views/BrandPriceAdjustment.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/product-price-adjustment',
		name: 'productPriceAdjustment',
		component: () => import('../views/ProductPriceAdjustment.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/shop-orders/:shopId',
		name: 'shopOrders',
		component: () => import('../views/ShopOrders.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/check-products',
		name: 'checkProducts',
		component: () => import('../views/CheckProducts.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/export-promotions',
		name: 'exportPromotion',
		component: () => import('../views/ExportPromotions.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/export-return',
		name: 'exportReturn',
		component: () => import('../views/ExportReturn.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/export-transfers',
		name: 'exportTransfers',
		component: () => import('../views/ExportTransfers.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/export-dp',
		name: 'exportDirectPurchase',
		component: () => import('../views/ExportDP.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/shop-product-check',
		name: 'shopProductCheck',
		component: () => import('../views/ShopProductCheck.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/sync-changes',
		name: 'syncChanges',
		component: () => import('../views/SyncChanges.vue'),
		meta: {
			title: 'Sync Changes - Beauty Diary POS',
			auth: true
		}
	},
	{
		path: '/heartbeat',
		name: 'heartbeat',
		component: () => import('../views/Heartbeat.vue'),
		meta: {
			title: 'Heartbeat - Beauty Diary POS',
			auth: true
		}
	},
	{
		path: '/top-sales',
		name: 'topSales',
		component: () => import('../views/TopSales.vue'),
		meta: {
			title: 'Top Sales - Beauty Diary POS',
			auth: true
		}
	},
	{
		path: '/order-item-report',
		name: 'orderItemReport',
		component: () => import('../views/OrderItemReport.vue'),
		meta: {
			title: 'Top Sales - Beauty Diary POS',
			auth: true
		}
	},
	{
		path: '/stock-adjustment',
		name: 'stockAdjustment',
		component: () => import('../views/StockAdjustment.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/warehouse-product-add',
		name: 'warehouseProductAdd',
		component: () => import('../views/WarehouseProductAdd.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/order-report',
		name: 'orderReport',
		component: () => import('../views/OrderReport.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/export-stock-total',
		name: 'exportStockTotal',
		component: () => import('../views/ExportStockTotal.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/ledger',
		name: 'ledger',
		component: () => import('../views/Ledger.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/export/stock-adjustment',
		name: 'exportStockAdjustment',
		component: () => import('../views/Stock_Adjustment__Export.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/order-items/detail-report',
		name: 'itemDetailsReport',
		component: () => import('../views/order_items__detail_report.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/export/product-transfer',
		name: 'exportProductTransfer',
		component: () => import('../views/ExportProductTransfer.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/search/promotions',
		name: 'searchPromotions',
		component: () => import('../views/SearchPromotions.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/export/mismatch-products',
		name: 'exportMismatchProducts',
		component: () => import('../views/Export__Product_Mismatch.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/stock/sync-check',
		name: 'stockSyncChecker',
		component: () => import('../views/Stock_Sync_Checker.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/autoid/check',
		name: 'autoIdCheck',
		component: () => import('../views/AutoID__Check.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/delete/orders',
		name: 'deleteOrders',
		component: () => import('../views/DeleteOrders.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/delete/products',
		name: 'deleteProducts',
		component: () => import('../views/DeleteProducts.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/export/member-rewards',
		name: 'exportMemberRewards',
		component: () => import('../views/ExportMemberRewards.vue'),
		meta: {
			auth: true
		}
	},
	{
		path: '/export/members',
		name: 'exportMembers',
		component: () => import('../views/ExportMembers.vue'),
		meta: {
			auth: true
		}
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

// router.beforeEach((to, from, next) => {
//   console.log(Store.state.route.query);

//   if (to.meta.auth && !Store.state.auth) {
//     next("/");
//   } else if (Store.state.auth && to.name == "login" && to.name !== "logout") {
//     next("/orders");
//   } else {
//     next();
//   }
// });

export default router
